
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "05f08e82-f15e-47a6-9606-32745456dfc7"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
